import react from 'react'
import CarImg from '../assets/img/car.png'
import { Link } from 'react-router-dom'
import salesForceGradient from '../assets/img/salesforceGradient.png'
import truck from '../assets/img/truck.png'
import cycle from '../assets/img/cycle.jpg'
import carMan from '../assets/img/carMan.png'
import featuresNumber from '../assets/img/featuresNumber.png'
import React, { useState } from "react";
import AutoMobile from '../../src/assets/img/automobile.png'
import carMan2 from '../../src/assets/img/car_man2.png'
import tempu2 from '../../src/assets/img/tempu2.jpg'
import "./index.css"


const Industries = () => {
    const [activeLink, setActiveLink] = useState("#sol1");
    const [selected, setSelected] = useState("OEM");
    
    const [selectedOption, setSelectedOption] = useState("OEM"); // Default selection
  const [selectedType, setSelectedType] = useState("all"); 

  const handleOptionClick = (id) => {
    setSelected(id)
    setSelectedOption(id);
    setSelectedType("all"); // Reset type when changing option
  };

  const options = [
    {
      id: "OEM",
      title: "OEM",
      description: "Explore OEM's ready to implement features",
      items: [
        { type: "all", name: "Remote Diagnostics" },
        { type: "service", name: "Bay Management" },
        { type: "sales", name: "Entitlement Management" },
        { type: "marketing", name: "Recall Management" },
        { type: "service", name: "Dealer Onboarding with ROI Calculation" },
        { type: "sales", name: "OEM Order Placement" },
        // Add more items as needed
      ],
    },
    {
      id: "Dealers",
      title: "Dealers",
      description: "Explore Dealers Customer's ready-to-implement features",
      items: [
        { type: "all", name: "Warranty & Claim Management" },
        { type: "marketing", name: "Spare Parts Inventory Management" },
        { type: "sales", name: "Spares & Accessories Ordering" },
        { type: "service", name: "ERP Integration" },
        // Add more items as needed
      ],
    },
    {
      id: "Customers",
      title: "Customers",
      description: "Explore Customer's ready-to-implement features",
      items: [
        { type: "all", name: "CTI Integration" },
        { type: "service", name: "Service Analytics and Reporting" },
        { type: "marketing", name: "Job Card Creation" },
        { type: "sales", name: "Telematics Integration" },
        // Add more items as needed
      ],
    },
  ];

  const filteredItems = options
  .find((option) => option.id === selectedOption)
  ?.items.filter((item) => selectedType === "all" || item.type === selectedType);

    const handleLinkClick = (link) => {
        setActiveLink(link);
      };



      const solutions = [
        { title: 'OEM', items: ['4W', '2W', '3W', 'Bicycle'] },
        { title: 'Component Manufacturers', items: ['Auto Lightning', 'Brakes', 'Electricals etc', 'Train Waggons', 'Tailers', 'Helmet', 'Bicycle Components'] },
        { title: 'Captive Functions', items: ['Finance', 'Insurance', 'IT'] },
        { title: 'Aggregators', items: ['Leasing', 'Service', 'Used Vehicle', 'Ride Hailing', 'Trucks'] },
        { title: 'Manufacturers', items: ['Manufacturing companies making machines for Component Manufacturers'] },
        { title: 'Dealers', items: ['Large Dealer servicing many brands'] },
      ];


      
 


  const renderSelectedComponent = () => {
    switch (selected) {
      case "OEM":
        return <div className="p-4">OEM Component Loaded</div>;
      case "Dealers":
        return <div className="p-4">Dealers Component Loaded</div>;
      case "Customers":
        return <div className="p-4">Customers Component Loaded</div>;
      default:
        return null;
    }
  };
    return(
        <div className='flex flex-col justify-center items-center w-full p-4'>

          <div className='py-20 mb-6 hidden sm:block'>
            <div className='flex justify-center items-center w-full mb-4'>
                <h1 className='text-4xl font-bold'>Automobile Industry</h1>
            </div>

            <div className='text-center flex justify-center items-center mb-8'>
                <div className='text-center flex justify-center items-center max-w-5xl gap-10'>

                <img className="w-32 h-32 rounded-3xl object-cover" src={cycle} alt="Logo" />
                <div className='flex flex-col justify-center items-center gap-5'>

                <p className='font-medium text-[#555] max-w-4xl mb-4'>Driving automotive business to new heights with our comprehensive Salesforce solutions. From enhancing customer engagement to streamlining operations, designed to meet the unique needs of the automotive industry.</p>
                <Link
                    to="/contact-sales"
                    className="group inline-block py-2 px-4 rounded-lg font-medium text-white bg-gradient-to-r from-[#0F8CC7] to-[#33C9B7] transition-all duration-500 ease-in-out transform group-hover:rotate-90 group-hover:from-[#33C9B7] group-hover:to-[#0F8CC7]"
                >
                    Request a demo
                </Link>

                </div>
                <img className="w-32 h-32 rounded-full object-cover" src={cycle} alt="Logo" />
                </div>
            </div>


            <div className="flex flex-wrap lg:flex-nowrap w-full h-auto max-w-6xl">
  {/* Section 1 */}
  <div className="flex-1 flex items-end rounded-2xl overflow-hidden bg-gray-100 hidden lg:flex flex-shrink-0">
    <img src={salesForceGradient} alt="Image 1" className="w-full object-cover" />
  </div>

  {/* Section 2 */}
  <div className="flex-1 flex items-start rounded-2xl overflow-hidden bg-gray-200 flex-shrink-0">
    <img src={truck} alt="Image 2" className="w-full object-cover" />
  </div>

  {/* Section 3 (Middle Section with Larger Width) */}
  <div className="flex-[1.5] flex items-end rounded-2xl overflow-hidden bg-gray-300 flex-shrink-0">
    <img src={cycle} alt="Image 3" className="w-full object-cover" />
  </div>

  {/* Section 4 */}
  <div className="flex-1 flex items-start rounded-2xl overflow-hidden bg-gray-400 flex-shrink-0">
    <img src={carMan} alt="Image 4" className="w-full object-cover" />
  </div>

  {/* Section 5 */}
  <div className="flex-1 flex items-end rounded-2xl overflow-hidden bg-gray-500 hidden lg:flex flex-shrink-0">
    <img src={featuresNumber} alt="Image 5" className="w-full object-cover" />
  </div>
</div>

</div>


{/* mobile view */}


<section className="block lg:hidden pb-5" id="culture">
      <div className="container mx-auto pb-5">
        <div className="flex flex-col items-center text-center">
          <h1 className="text-2xl font-bold pt-2">Automobile Industry</h1>

          {/* Main Image Section */}
          <div className="w-full h-44 pt-4">
            <img 
              src={cycle}
              alt="Automobile" 
              className="rounded-3xl object-cover	 h-full w-full"
            />
          </div>

          {/* Two Smaller Images */}
          <div className="flex justify-between w-full pt-3 space-x-3">
            <img 
              src={tempu2}
              alt="Tempu" 
              className="rounded-3xl w-[48%] max-w-full"
            />
            <img 
              src={carMan2}
              alt="Car Man" 
              className="rounded-3xl w-[48%] max-w-full"
            />
          </div>

          {/* Text Section */}
          <div className="pt-5 px-4">
            <p className="text-gray-700">
              Driving automotive business to new heights with our comprehensive Salesforce solutions. From enhancing customer engagement to streamlining operations, designed to meet the unique needs of the automotive industry.
            </p>
            <Link to="/contact_us" className='mt-5'>
              <button 
                  className="mt-5 group inline-block py-2 px-4 rounded-lg font-medium text-white bg-gradient-to-r from-[#0F8CC7] to-[#33C9B7] transition-all duration-500 ease-in-out transform group-hover:rotate-90 group-hover:from-[#33C9B7] group-hover:to-[#0F8CC7]">
                Request a demo
              </button>
            </Link>
          </div>

              {/* Two Smaller Images */}
              <div className="flex justify-between h-36 w-full pt-3 mt-5 space-x-3">
            <img 
              src={salesForceGradient}
              alt="Tempu" 
              className="rounded-3xl w-[48%] max-w-full object-cover"
            />
            <img 
              src={featuresNumber}
              alt="Car Man" 
              className="rounded-3xl w-[48%] max-w-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>



    <div className="hidden lg:block w-full sticky top-[59px] bg-[#F7F7F7] z-20" id="Features_scroll1">
      <div className="container mx-auto z-20 bg-[#F7F7F7]">
        <div className="hidden lg:flex bg-[#F7F7F7]">

          {/* Home / Automobile Industry */}
          <div className="lg:w-1/3 pl-10">
            <p className="pl-10 py-2 m-0 text-gray-700 font-medium">
              Home / Automobile Industry
            </p>
          </div>

          {/* Solutions */}
          <div
            className={`lg:w-1/6 text-center ${activeLink === "#sol1" ? "bg-[#DDD6D6]" : "bg-transparent"}`}
            onClick={() => handleLinkClick("#sol1")}
          >
            <p className="m-0">
              <a
                href="#sol1"
                className="nav-linktab block py-2 text-gray-700 font-medium hover:text-blue-500"
              >
                Solutions
              </a>
            </p>
          </div>

          {/* Segments */}
          <div
            className={`lg:w-1/6 text-center ${activeLink === "#sol2" ? "bg-[#DDD6D6]" : "bg-transparent"}`}
            onClick={() => handleLinkClick("#sol2")}
          >
            <p className="m-0">
              <a
                href="#sol2"
                className="nav-linktab block py-2 text-gray-700 font-medium hover:text-blue-500"
              >
                Segments
              </a>
            </p>
          </div>

          {/* Transforming */}
          <div
            className={`lg:w-1/6 text-center ${activeLink === "#sol3" ? "bg-[#DDD6D6]" : "bg-transparent"}`}
            onClick={() => handleLinkClick("#sol3")}
          >
            <p className="m-0">
              <a
                href="#sol3"
                className="nav-linktab block py-2 text-gray-700 font-medium hover:text-blue-500"
              >
                Transforming
              </a>
            </p>
          </div>

          {/* Insights */}
          <div
            className={`lg:w-1/6 text-center ${activeLink === "#sol4" ? "bg-[#DDD6D6]" : "bg-transparent"}`}
            onClick={() => handleLinkClick("#sol4")}
          >
            <p className="m-0">
              <a
                href="#sol4"
                className="nav-linktab block py-2 text-gray-700 font-medium hover:text-blue-500"
              >
                Insights
              </a>
            </p>
          </div>

        </div>
      </div>
    </div>
    <div className="flex flex-col items-center w-full bg-gray-50 hidden sm:block">
      <h1 className="text-3xl text-center font-bold mb-8">Automotive Industry Solution</h1>
      <div className="w-full bg-white rounded-lg shadow-md">
        {solutions.map((solution, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row items-start md:items-center  p-6 ${
              index % 2 === 0 ? 'bg-[#EAF5FE]' : 'bg-white'
            }`}
          >
            <h2 className="text-lg font-semibold mb-4 md:mb-0 w-1/4">{solution.title}</h2>
            <div className="flex flex-wrap gap-3">
              {solution.items.map((item, idx) => (
                <span
                  key={idx}
                  className="px-4 py-2 bg-white  rounded-2xl shadow-md text-gray-700 font-medium"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>

    <div class="flex flex-col lg:flex-row items-start justify-between w-full p-6 bg-gray-100 rounded-lg p-20 h-full">

  <div class="flex-1">
    <h1 class="text-2xl text-[#0D4282] font-medium text-gray-800 mb-2">Automotive Salesforce Solutions: Driving Innovation and Excellence</h1>
    <p class="text-gray-600 mb-4">
      In a rapidly changing industry, automotive businesses need agile solutions to stay competitive. Our Salesforce solutions address the unique challenges of the automotive sector like enhance customer engagement, streamline operations, and drive growth. From optimizing dealer management to enabling data-driven decisions, we help you achieve excellence in the modern automotive market.
    </p>
    <div class="flex  flex-col lg:flex-row gap-4 w-full">
      <div class="flex flex-col w-full  p-6 w-40 h-32  bg-blue-500 text-white rounded-3xl shadow-2xl " >
        <span class="text-3xl font-bold text-black">145%</span>
        <span class="text-sm text-black">Increase in Click throughrate</span>
      </div>

      <div class="flex flex-col  w-full p-6 w-40 h-32 bg-green-500 text-white rounded-3xl shadow-2xl" >
        <span class="text-3xl text-black font-bold">30%</span>
        <span class="text-sm text-black">more lead capture via automated journey</span>
      </div>
    </div>
  </div>


  <div class="flex-1 relative mt-6 lg:mt-0 h-full items-start hidden lg:flex">
    <img
      src={AutoMobile}
      alt="Example"
      class="align-right w-72 h-72 object-cover rounded-lg shadow-lg ml-auto"
    />
  </div>

</div>


{/* OEM DEALERS CUSTOMERs option selection area */}
<div className="max-w-6xl mx-auto p-6">
      <h2 className="text-3xl sm:text-4xl font-semibold sm:font-bold mb-6 text-gray-800">
        Delivering complete automotive solution covering OEM’s, Dealers and Customers
      </h2>

      <div className="flex  flex-wrap gap-6 mb-6">
        {options.map((option) => (
          <>
          <div
            key={option.id}
            onClick={() => handleOptionClick(option.id)}
            className={` flex flex-1 min-w-72 flex-col items-start justify-between p-10 rounded-2xl shadow-lg cursor-pointer  h-56 transition-all duration-300 ${
              selected === option.id ? "border border-[#00A1E0]" : ""
            } ${selected === option.id ? "bg-blue-50" : "bg-white"}`}
          >
            <h3 className="text-2xl font-bold text-gray-800 mb-2">{option.title}</h3>
            <p className="text-md text-gray-600 mb-4">{option.description}</p>
            <div
              className={`w-6 h-6 rounded-full border-4 flex items-center justify-center ${
                selected === option.id ? "border-[#00A1E0]" : "border-gray-300"
              }`}
            >
              {selected === option.id && <div className="w-3 h-3 bg-blue-500 rounded-full"></div>}
            </div>

          </div>
                {/* Render Additional Content Below Selected Option */}


                {selected === option.id && (
            <div className=" md:hidden block">
              {/* Type Filters */}
              <div className="flex gap-4 mb-6">
                {["all", "marketing", "sales", "service"].map((type) => (
                  <button
                    key={type}
                    className={`px-4 py-2 font-medium rounded ${
                      selectedType === type ? "bg-blue-500 text-[#0FA7E2]" : "bg-gray-200"
                    }`}
                    onClick={() => setSelectedType(type)}
                  >
                    {type.charAt(0).toUpperCase() + type.slice(1)}
                  </button>
                ))}
              </div>

              {/* Items List */}
              <div className=" md:hidden grid grid-cols-1 shadow-lg border border-gray-300 p-10 rounded-lg gap-4">
                {filteredItems.map((item, index) => (
                  <div key={index} className="border-b-4 border-[#ECECEC] pb-4">
                    {index + 1}. {item.name}
                  </div>
                ))}
              </div>
            </div>
          )}

                  


          </>

        ))}
      </div>

      <div class="max-w-6xl mx-auto text-left py-8 px-4">
        <h1 className="text-2xl lg:text-3xl font-medium text-[#0D4282] leading-relaxed">
        Revolutionize Your Automotive Business with CRM Landing: Your Partner in Digital Transformation
          </h1>  
          <p className='mt-4 text-gray-600 text-sm lg:text-base'>
          Explore the key features that will propel your dealership into the digital era, streamline your operations, and elevate customer experiences. Our innovative solutions are designed to help you adapt to the evolving technology.
          </p>
      </div>

      {/* <div className="border-t pt-6">{renderSelectedComponent()}</div> */}
    </div>


    <div className="p-4 w-full">
      
      {/* Type Filters */}
      <div className="flex gap-4 mb-6">
        {["all", "marketing", "sales", "service"].map((type) => (
          <button
            key={type}
            className={`px-4 py-2 font-medium rounded ${
              selectedType === type ? "bg-blue-500 text-[#0FA7E2]" : "bg-gray-200"
            }`}
            onClick={() => setSelectedType(type)}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>

      {/* Items List */}
      <div className="grid grid-cols-1 shadow-lg border-[#B4B4B4] p-10 rounded-lg sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredItems?.map((item, index) => (
          <div
            key={index}
            className="border-b-4 border-[#ECECEC] pb-4 transition"
          >
            {index + 1}. {item.name}
          </div>
        ))}
      </div>
    </div>














</div>






    )
}

export default Industries